<div style="margin-top: 20px;">
  <p8-list-comments *ngIf="Loaning?.id"
                    [object_id]="Loaning?.id"
                    [content_type]="Loaning?.content_type"
                    [canSeePrivate]="false"></p8-list-comments>

  <p8-comment *ngIf="Loaning?.id" [object_id]="Loaning?.id" [content_type]="Loaning?.content_type"
              [application]="application"
              [hasPrivate]="false" [hasFilesToUpload]="true" [maxFiles]="1"
              [sendMail]="true" [sendTosPublic]="emails"
              [linkToOpenOrTitle]="this"></p8-comment>
</div>

